// extracted by mini-css-extract-plugin
module.exports = {"bankData":"RegistrationPaymentStep_bankData_3V1Pf"};